import { render, staticRenderFns } from "./comp0.vue?vue&type=template&id=eebaf87a&scoped=true"
import script from "./comp0.vue?vue&type=script&lang=ts"
export * from "./comp0.vue?vue&type=script&lang=ts"
import style0 from "./comp0.vue?vue&type=style&index=0&id=eebaf87a&prod&scoped=true&lang=scss"
import style1 from "./comp0.vue?vue&type=style&index=1&id=eebaf87a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebaf87a",
  null
  
)

export default component.exports